import icon4KG from "./4KG_icon.png";
import icon5KG from "./5KG_icon.png";
import icon10KG from "./10KG_icon.png";
import icon16KG from "./16KG_icon.png";
import icon20KG from "./20KG_icon.png";
import icon50KG from "./50KG_icon.png";

/** 依重量對應實際瓦斯桶照片。 */
export const GAS_IMAGE: Record<number, string> = {
  4: icon4KG,
  5: icon5KG,
  10: icon10KG,
  16: icon16KG,
  20: icon20KG,
  50: icon50KG,
};

/**
 * 瓦斯桶照片的高度，依重量縮放。
 *
 * 用立方根而不是重量本身：重量正比於體積，體積和高度是三次方關係。
 * 照重量線性縮放的話 5KG 只剩 50KG 的十分之一高——那不是「比較小」是「不見了」。
 * 立方根還原成真實的高度比，一排看過去才像同一組實際的桶子。
 *
 * @param box 容器高度（＝ 50KG 那一桶的高度）。商品格用 92、明細列用 30。
 */
export const cylinderHeight = (kg: number, box: number): number =>
  Math.round(box * (Math.cbrt(Math.max(kg, 1)) / Math.cbrt(50)));

/** 商品格的瓦斯桶容器高度。 */
export const CYLINDER_BOX = 92;
